const TRANSITION_END_GRACE_MS = 120;
const NO_FADE = { cancel: () => undefined };
export function showRevealBlur({ root, fromPx, durationMs, easing, }) {
    return showRevealTransition({
        target: root,
        fromPx,
        blurDurationMs: durationMs,
        blurEasing: easing,
    });
}
export function showRevealTransition({ target, fromPx, blurDurationMs, blurEasing, beforeCommit, }) {
    if (fromPx <= 0 || blurDurationMs <= 0) {
        beforeCommit?.();
        return NO_FADE;
    }
    const prevFilter = target.style.filter;
    const prevTransition = target.style.transition;
    const prevWillChange = target.style.willChange;
    let done = false;
    let timer = undefined;
    const finish = () => {
        if (done)
            return;
        done = true;
        clearTimeout(timer);
        target.removeEventListener('transitionend', onTransitionEnd);
        target.style.filter = prevFilter;
        target.style.transition = prevTransition;
        target.style.willChange = prevWillChange;
    };
    function onTransitionEnd(event) {
        if (event.target !== target || event.propertyName !== 'filter')
            return;
        finish();
    }
    target.style.transition = '';
    target.style.willChange = 'filter';
    target.style.filter = `blur(${fromPx}px)`;
    beforeCommit?.();
    target.addEventListener('transitionend', onTransitionEnd);
    timer = setTimeout(finish, blurDurationMs + TRANSITION_END_GRACE_MS);
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            if (done)
                return;
            target.style.transition = `filter ${blurDurationMs}ms ${blurEasing}`;
            target.style.filter = prevFilter;
        });
    });
    return { cancel: finish };
}
//# sourceMappingURL=reveal-blur.js.map